import { IFontStyles, Separator, Stack, Text } from "@fluentui/react";

import NumberField, {
  commaNumber,
  parseInputNumber,
} from "../../../../NumberField";
import { actions } from "../../../slice";
import { useFormSummary } from "../utils";

export default () => {
  const summary = useFormSummary();
  const discountPercent = summary.discountAmount / summary.totalProductCost;

  return (
    <Stack>
      <Row title="Toplam" variant="mediumPlus">
        {commaNumber(summary.totalProductCost)} TL
      </Row>
      <Separator />
      <Row title="İskonto" variant="mediumPlus">
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
          <small>
            (%
            {(
              (discountPercent && !isNaN(discountPercent)
                ? discountPercent
                : 0) * 100
            ).toFixed(2)}
            )
          </small>
          <NumberField
            suffix="TL"
            value={
              summary.discountAmount && !isNaN(summary.discountAmount)
                ? summary.discountAmount.toString()
                : ""
            }
            onChange={(_, nv) => {
              const x = parseInputNumber(nv);
              actions.setFormDiscountValue(["currency", x || 0]);
            }}
          />
        </Stack>
      </Row>
      <Separator />
      <Row title="Genel Toplam" variant="xLarge">
        {commaNumber(summary.grandTotal)} TL
      </Row>
    </Stack>
  );
};

const Row = (props: {
  title: string;
  variant: keyof IFontStyles;
  children?: React.ReactNode;
}) => {
  return (
    <Stack horizontal>
      <Text variant={props.variant}>{props.title}:</Text>
      <Stack grow horizontalAlign="end">
        <Text variant={props.variant}>{props.children}</Text>
      </Stack>
    </Stack>
  );
};
